export const SETTINGS_HOME = 'SETTINGS_HOME'
export const SETTINGS_HOME_DISPLAY = `${SETTINGS_HOME}__DISPLAY`
export const SETTINGS_HOME_REGION = `${SETTINGS_HOME}_REGION`
export const SETTINGS_HOME_SHOW = `${SETTINGS_HOME}_SHOW`
export const SETTINGS_HOME_SORT = `${SETTINGS_HOME}_SORT`
export const SETTINGS_FRIENDS_DISPLAY_TYPE = `SETTINGS_FRIENDS_DISPLAY_TYPE`
